"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var messaging_1 = require("./model/messaging");
var MessagingApi = /** @class */ (function () {
    function MessagingApi(api, apiConnector) {
        this._api = api;
        this._apiConnector = apiConnector;
    }
    MessagingApi.prototype.msgApi = function () {
        return this._api.instance().msg_api();
    };
    MessagingApi.prototype.execute = function (operation) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._apiConnector.connection()
                .then(function () {
                _this.msgApi()
                    .exec(operation.name, operation.parameters)
                    .then(function (content) { return resolve(content); })
                    .catch(function (err) {
                    reject(_this.handleError(messaging_1.MessagingError.query_execution_failed, err));
                });
            })
                .catch(function (err) {
                reject(_this.handleError(messaging_1.MessagingError.api_connection_failed, err));
            });
        });
    };
    MessagingApi.prototype.handleError = function (databaseErrorMessage, err) {
        var error = new Error(databaseErrorMessage);
        error.stack = err;
        return error;
    };
    return MessagingApi;
}());
exports.MessagingApi = MessagingApi;
//# sourceMappingURL=messaging.js.map


//////////////////
// WEBPACK FOOTER
// ./lib/api/messaging.js
// module id = 231
// module chunks = 0